(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function videoUrlToEmbed(url) {
      if (!url) return '';
      try {
        const u = new URL(url);
        if (u.hostname.includes('youtube.com') && u.searchParams.has('v')) {
          const id = u.searchParams.get('v');
          const start = u.searchParams.get('t') || '';
          const startSec = start ? String(parseInt(start, 10) || 0) : '';
          return 'https://www.youtube.com/embed/' + id + (startSec ? '?start=' + startSec : '');
        }
        if (u.hostname === 'youtu.be') {
          const id = u.pathname.slice(1).split('/')[0];
          const start = u.searchParams.get('t') || '';
          const startSec = start ? String(parseInt(start, 10) || 0) : '';
          return 'https://www.youtube.com/embed/' + id + (startSec ? '?start=' + startSec : '');
        }
        if (u.hostname.includes('vimeo.com')) {
          const m = u.pathname.match(/\/(\d+)/);
          return m ? 'https://player.vimeo.com/video/' + m[1] : '';
        }
      } catch (_) {}
      return '';
    }

    document.querySelectorAll('[data-hero-video-trigger]').forEach(function (trigger) {
      const dialog = trigger.parentElement?.querySelector('[data-hero-video-dialog]');
      const iframe = dialog?.querySelector('[data-hero-video-iframe]');
      const closeBtn = dialog?.querySelector('[data-hero-video-close]');
      if (!dialog || !iframe) return;

      function open() {
        const url = trigger.getAttribute('data-video-url');
        const embedSrc = videoUrlToEmbed(url);
        if (embedSrc) {
          iframe.src = embedSrc;
          dialog.showModal();
        }
      }

      function close() {
        iframe.src = '';
        dialog.close();
      }

      trigger.addEventListener('click', open);
      closeBtn?.addEventListener('click', close);
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) close();
      });
      dialog.addEventListener('cancel', close);
      dialog.addEventListener('close', close);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
